<template>
	<div class="form-group" :class="{'mb-0': field.type == 'Display Text'}" v-show="!field.cantView && shouldShow()">
		<label :for="'field-'+field.id" v-show="!field.valueOnly">
			<span v-if="field.label" v-html="field.label"></span>
			<small
				v-if="field.required || (field.validation_settings && field.validation_settings.required)"
				class="ml-2 text-danger"
				data-tooltip="Indicates a required field"
			>*</small>
		</label>
		<div
			v-show="!field.valueOnly"
			v-if="field.directions && field.type != 'Display Text'"
			class="text-muted"
			v-html="field.directions"
		></div>
		<div v-if="field.type == 'Text Box' || field.type == 'Money'">
			<input style="display:none" type="text" name="fakefield" />
			<div v-if="field.type_attributes.indexOf('Single Line') > -1">
				<input
					:name="'field-'+field.id"
					:ref="field.type_attributes.indexOf('Autocomplete') > -1 ? 'autocomplete' : null"
					class="form-control data-hj-allow"
					:class="fieldAlt ? 'form-control-alt '+classes : classes"
					type="text"
					v-model="field.value"
					@blur="changed"
					:disabled="field.type_attributes.indexOf('Disabled') > -1"
					:readonly="field.type_attributes.indexOf('Readonly') > -1"
					:placeholder="field.placeholder"
					:data-required="field.required || (field.validation_settings && field.validation_settings.required) ? 'true' : 'false'"
					autocomplete="off"
				/>
			</div>
			<div v-else>
				<textarea
					:rows="rows"
					:name="'field-'+field.id"
					class="form-control data-hj-allow"
					:class="fieldAlt ? 'form-control-alt '+classes : classes"
					v-model="field.value"
					@blur="changed"
					:disabled="field.type_attributes.indexOf('Disabled') > -1"
				>{{field.placeholder}}</textarea>
			</div>
		</div>
		<div v-else-if="field.type == 'Select' || field.type == 'Drop Down'">
			<div
				v-if="field.type_attributes.indexOf('Single Select') > -1 || field.type_attributes.indexOf('Single Line') > -1"
			>
				<select
					:name="'field-'+field.id"
					class="form-control data-hj-allow"
					:class="fieldAlt ? 'form-control-alt '+classes : classes"
					v-model="field.value"
					@change="changed"
					:disabled="field.type_attributes.indexOf('Disabled') > -1"
				>
					<option :value="null">- Select One -</option>
					<option v-for="option in field.value_options" :value="option.id ? option.id : option">{{ option.name ? option.name : option }}</option>
				</select>
			</div>
			<div v-else>
				<multiselect
					class="data-hj-allow"
					v-model="multiselectValue"
					:options="field.value_options"
					:multiple="true"
					:close-on-select="false"
					track-by="id"
					label="name"
					:disabled="field.type_attributes.indexOf('Disabled') > -1"
				></multiselect>
			</div>
		</div>
		<div v-if="field.type == 'Password'">
			<div class="input-group">
				<input style="display:none" type="password" name="fakefield" />
				<div class="input-group-prepend">
					<span
						class="input-group-text"
						:class="fieldAlt ? 'input-group-text-alt '+classes : classes"
					>
						<span class="bw-vl-info-icon-form fa fa-lock"></span>
					</span>
				</div>
				<input
					:id="field.type_attributes.indexOf('Confirm') == -1 ? 'password' : 'password-confirm'"
					:name="'field-'+field.id"
					type="password"
					class="form-control"
					:class="fieldAlt ? 'form-control-alt '+classes : classes"
					v-model="field.value"
					@blur="changed"
					autocomplete="new-password"
					:disabled="field.type_attributes.indexOf('Disabled') > -1"
					:data-required="field.required || (field.validation_settings && field.validation_settings.required) ? 'true' : 'false'"
				/>
			</div>
		</div>
		<div v-if="field.type == 'Phone'">
			<div class="input-group">
				<input style="display:none" type="text" name="fakefield" />
				<div class="input-group-prepend">
					<span
						class="input-group-text"
						:class="fieldAlt ? 'input-group-text-alt '+classes : classes"
					>
						<span class="bw-vl-info-icon-form bw-phone-icon"></span>
					</span>
				</div>
				<input
					:name="'field-'+field.id"
					type="text"
					class="form-control data-hj-allow"
					:class="fieldAlt ? 'form-control-alt '+classes : classes"
					v-model="field.value"
					v-phone="field.value"
					@blur="changed"
					:disabled="field.type_attributes.indexOf('Disabled') > -1"
					:data-required="field.required || (field.validation_settings && field.validation_settings.required) ? 'true' : 'false'"
					autocomplete="off"
					placeholder="ex: (555) 321 - 0498"
					autocorrect="off"
          			autocapitalize="none"
				/>
			</div>
		</div>
		<div v-if="field.type == 'Date'">
			<input style="display:none" type="text" name="fakefield" />
			<div style="position: relative">
				<date-picker
					:config="{format: 'MM/DD/YYYY'}"
					:class="fieldAlt ? 'form-control-alt '+classes : classes"
					:value="field.value"
					@dp-hide="saveDate($event.target.value, 'MM/DD/YYYY')"
					:disabled="field.type_attributes.indexOf('Disabled') > -1"
					placeholder="format: MM/DD/YYYY"
				></date-picker>
			</div>
		</div>
		<div v-if="field.type == 'Email'">
			<div class="input-group">
				<input style="display:none" type="text" name="fakefield" />
				<div class="input-group-prepend">
					<span
						class="input-group-text"
						:class="fieldAlt ? 'input-group-text-alt '+classes : classes"
					>
						<span class="fa fa-envelope"></span>
					</span>
				</div>
				<input
					:name="'field-'+field.id"
					type="text"
					class="form-control email data-hj-allow"
					:class="fieldAlt ? 'form-control-alt '+classes : classes"
					v-model="field.value"
					@blur="changed"
					:disabled="field.type_attributes.indexOf('Disabled') > -1"
					:data-required="field.required || (field.validation_settings && field.validation_settings.required) ? 'true' : 'false'"
					autocomplete="off"
					placeholder="ex: john@doe.com"
				/>
			</div>
		</div>
		<div v-if="field.type == 'GooglePlace'">
			<div class="input-group">
				<input style="display:none" type="text" name="fakefield" />
				<div class="input-group-prepend">
					<span
						class="input-group-text"
						:class="fieldAlt ? 'input-group-text-alt '+classes : classes"
					>
						<span class="fa fa-search"></span>
					</span>
				</div>
				<input
					:name="'field-'+field.id"
					ref="autocomplete"
					type="text"
					class="form-control data-hj-allow"
					:class="fieldAlt ? 'form-control-alt '+classes : classes"
					v-model="field.value"
					@blur="changed"
					:disabled="field.type_attributes.indexOf('Disabled') > -1"
					:data-required="field.required || (field.validation_settings && field.validation_settings.required) ? 'true' : 'false'"
					autocomplete="off"
				/>
			</div>
		</div>
		<div v-if="field.type == 'Website'">
			<div class="input-group">
				<input style="display:none" type="text" name="fakefield" />
				<div class="input-group-prepend">
					<span
						class="input-group-text"
						:class="fieldAlt ? 'input-group-text-alt '+classes : classes"
					>
						<span class="si si-globe"></span>
					</span>
				</div>
				<input
					:name="'field-'+field.id"
					type="text"
					class="form-control data-hj-allow"
					:class="fieldAlt ? 'form-control-alt '+classes : classes"
					v-model="field.value"
					@blur="changed"
					:disabled="field.type_attributes.indexOf('Disabled') > -1"
					:data-required="field.required || (field.validation_settings && field.validation_settings.required) ? 'true' : 'false'"
					autocomplete="off"
					placeholder="ex: https://www.google.com"
				/>
			</div>
		</div>
		<div v-else-if="field.type == 'Text Area'">
			<textarea
				:rows="rows"
				:name="'field-'+field.id"
				class="form-control data-hj-allow"
				:class="fieldAlt ? 'form-control-alt '+classes : classes"
				v-model="field.value"
				@blur="changed"
			>{{field.placeholder}}</textarea>
		</div>
		<div v-else-if="field.type == 'Check Box'">
			<div v-for="(option, index) in field.value_options" class="custom-control custom-checkbox" :key="parentId+'-field-'+field.id+'-option-'+index">
				<input
					type="checkbox"
					class="custom-control-input"
					:class="[fieldAlt ? 'form-control-alt '+classes : classes, field.type_attributes.indexOf('Disabled') > -1 ? 'disabled' : '']"
					:id="parentId+'-field-'+field.id+'-option-'+index"
					:name="parentId+'field-'+field.id+'-option-'+index"
					:value="option"
					:checked="field.value && field.value.indexOf(option) > -1"
					@click="toggleCheckbox(field.value, option)"
					@change="changed"
				/>
				<label
					class="custom-control-label"
					:class="field.type_attributes.indexOf('Disabled') > -1 ? 'disabled' : ''"
					:for="parentId+'field-'+field.id+'-option-'+index"
					@click="field.value = toggleCheckbox(field.value, option)"
				>{{option}}</label>
			</div>
		</div>
		<div v-else-if="field.type == 'Radio'">
			<div v-for="(option, index) in field.value_options" class="custom-control custom-radio" :key="parentId+'-field-'+field.id+'-option-'+index">
				<input
					type="radio"
					class="custom-control-input"
					:class="[fieldAlt ? 'form-control-alt '+classes : classes, field.type_attributes.indexOf('Disabled') > -1 ? 'disabled' : '']"
					:id="parentId+'-field-'+field.id+'-option-'+index"
					:name="'field-'+field.id"
					:value="option"
					:index="index"
					:disabled="field.type_attributes.indexOf('Disabled') > -1"
					v-model="field.value"
					@click="toggleRadio(option, field.type_attributes.indexOf('Disabled') > -1)"
					@change="changed"
				/>
				<label
					class="custom-control-label"
					:class="field.type_attributes.indexOf('Disabled') > -1 ? 'disabled' : ''"
					:for="'field-'+field.id+'-option-'+index"
					@click="toggleRadio(option, field.type_attributes.indexOf('Disabled') > -1)"
				>{{option}}</label>
			</div>
		</div>
		<div v-else-if="field.type == 'Categories'">
			<div v-if="parentCategories.length">
			<div v-for="option in parentCategories" class="custom-control custom-radio">
				<input
						type="radio"
						class="custom-control-input"
						:class="[fieldAlt ? 'form-control-alt '+classes : classes, field.type_attributes.indexOf('Disabled') > -1 ? 'disabled' : '']"
						:id="parentId+'-field-'+field.id+'-option-'+option.id"
						:name="'field-'+field.id+'-categories'"
						:value="option.id"
						:checked="field.value && field.value.indexOf(option.id) > -1"
						@click="toggleCategory(option.id, true)"
				/>
				<label
						class="custom-control-label"
						:class="field.type_attributes.indexOf('Disabled') > -1 ? 'disabled' : ''"
						:for="'field-'+field.id+'-option-'+option.id"
						@click="toggleCategory(option.id, true)"
				>{{option.name}}</label>
			</div>
			<div v-if="parentCategory && childCategories.length" class="mt-1">
				<label>Let's get a little bit more specific</label>
				<div v-for="option in childCategories" class="custom-control custom-checkbox" :key="parentId+'-field-'+field.id+'-option-'+option.id+'-categories'">
					<input
							type="checkbox"
							class="custom-control-input"
							:class="[fieldAlt ? 'form-control-alt '+classes : classes, field.type_attributes.indexOf('Disabled') > -1 ? 'disabled' : '']"
							:id="parentId+'-field-'+field.id+'-option-'+option.id+'-categories'"
							:name="parentId+'field-'+field.id+'-option-'+option.id+'-categories'"
							:key="parentId+'field-'+field.id+'-option-'+option.id+'-categories'"
							:value="option.id"
							:checked="field.value && field.value.indexOf(option.id) > -1"
							@click="toggleCategory(option.id)"
					/>
					<label
							class="custom-control-label"
							:class="field.type_attributes.indexOf('Disabled') > -1 ? 'disabled' : ''"
							:for="parentId+'field-'+field.id+'-option-'+option.id+'-categories'"
							@click="field.value = toggleCategory(option.id)"
					>{{option.name}}</label>
				</div>
			</div>
			</div>
			<div v-else>
				No Categories Found
			</div>
		</div>
		<div v-else-if="field.type == 'Image'">
			<div class="controls" v-if="media && media.length">
				<div class="fileupload fileupload-new" data-provides="fileupload" v-if="image">
					<div
						class="fileupload-preview fileupload thumbnail overflow-hidden"
						:style="getMediaStyle(image)"
						v-if="image.url"
					>
						<img class="w-100" :src="image.url" />
					</div>
					<div class="fileupload-new thumbnail" :style="getMediaStyle(image)" v-else>
						<img
							class="w-100"
							:src="'https://via.placeholder.com/'+image.width+'x'+image.height+'.png?text='+(field.type_attributes.indexOf('Square') > -1 ? 'Business Image 2' : field.type_attributes.indexOf('Header') > -1 ? 'Business Image' : field.type_attributes.indexOf('Logo') > -1 ? 'Business Logo' : 'Image')"
						/>
					</div>
					<span class="d-flex">
						<span @click="chooseImage(image)" v-if="!image.url" class="btn btn-success btn-sm m-1">
							<i class="fa fa-plus mr-2"></i>Select
						</span>
						<span @click="chooseImage(image)" v-if="image.url" class="btn btn-success btn-sm m-1">
							<i class="fa fa-sync mr-2"></i>Change
						</span>
						<span
							@click="chooseImage(image, 'edit')"
							v-if="image.url"
							class="btn btn-info btn-sm m-1"
						>
							<i class="fa fa-crop mr-2"></i>Crop
						</span>
						<span @click="removeImage(image)" v-if="image.url" class="btn btn-danger btn-sm m-1">
							<i class="fa fa-times mr-2"></i>Remove
						</span>
						<div class="flex-grow-1"></div>
					</span>
					<!--                    for validation-->
					<input
						type="text"
						:name="'field-'+field.id"
						:value="image.url"
						style="height: 0px !important; border: none !important; color: transparent !important;"
					/>
				</div>
			</div>
			<div v-else class="text-center">No Media to choose from</div>
		</div>
		<div v-else-if="field.type == 'Toggle'">
			<div class="custom-control custom-switch custom-control-primary mb-1">
				<input
					type="checkbox"
					class="custom-control-input"
					:value="field.value"
					v-model="field.value"
					@change="changeToggle()"
				/>
				<label class="custom-control-label" @click.prevent="changeToggle()">{{field.label}}</label>
			</div>
		</div>
		<div v-else-if="field.type == 'Business Hours'">
			<div v-for="day in days" class="d-flex flex-fill">
				<div class="custom-control custom-switch custom-control-primary mb-1">
					<input
						type="checkbox"
						class="custom-control-input"
						:value="day.selected"
						v-model="day.selected"
						@change="daySelected(day)"
						:disabled="field.type_attributes.indexOf('Disabled') > -1"
					/>
					<label class="custom-control-label" @click.prevent="daySelected(day)">{{day.label}}</label>
				</div>
				<div v-if="day.selected" class="d-flex flex-fill mr-2 ml-2 mb-1">
					<div style="position: relative">
						<date-picker
							:config="{format: 'h:mm A'}"
							:value="day.open"
							@dp-hide="day.open = $event.target.value; formatDayText()"
							:class="'form-control-sm'"
							:disabled="field.type_attributes.indexOf('Disabled') > -1"
						></date-picker>
					</div>
					<span class="mr-2 ml-2">-</span>
					<div style="position: relative">
						<date-picker
							:config="{format: 'h:mm A'}"
							:value="day.close"
							@dp-hide="day.close = $event.target.value; formatDayText()"
							:class="'form-control-sm'"
							:disabled="field.type_attributes.indexOf('Disabled') > -1"
						></date-picker>
					</div>
				</div>
				<div v-else>- Closed</div>
			</div>
		</div>
		<div v-else-if="field.type == 'Display Image'">
			<div class="w-100" :class="field.type_attributes.indexOf('Center') > -1 ? 'text-center' : ''">
				<img class="w-100" v-if="field.value" :src="field.value" style="max-width: 450px" />
				<div v-else class="m-5">{{ field.label || field.name }} will display here</div>
			</div>
		</div>
		<div v-else-if="field.type == 'Display Text'">
			<div
				v-html="field.directions"
				:class="field.type_attributes.indexOf('Center') > -1 ? 'text-center' : ''"
			></div>
			<span v-if="field.value">{{field.value}}</span>
		</div>
		<div v-else-if="field.type == 'RedemptionFrequency'">
			<select
					:name="'field-'+field.id"
					class="form-control data-hj-allow"
					:class="fieldAlt ? 'form-control-alt '+classes : classes"
					v-model="field.value"
					@change="changed"
					:disabled="field.type_attributes.indexOf('Disabled') > -1"
			>
				<option :value="null">- Select One -</option>
				<option :value="'0_1_months'" v-if="field.settings && field.settings.single_use">Single-use</option>
				<option :value="'1_1_days'" v-if="field.settings && field.settings.repeat">Repeat once daily</option>
				<option :value="'1_1_weeks'" v-if="field.settings && field.settings.repeat">Repeat once a week</option>
				<option :value="'1_1_months'" v-if="field.settings && field.settings.repeat">Repeat once a month</option>
			</select>
		</div>
		<div v-else-if="field.type == 'GridSelection'">
			<v-row>
				<v-col
						v-for="(option, idx) in field.value_options"
						:key="`redemption-option-${idx}`"
						cols="12"
						md="4"
				>
					<label class="redemption-selection">
						<input
								v-model="field.value"
								class="redemption-selection__radio"
								:value="option.name"
								type="radio"
								name="redemption"
								@change="changed"
						/>
						<v-card
								color="grey lighten-4"
								:flat="field.value !== option.name"
								:elevation="field.value === option.name ? 6 : undefined"
								:style="{'selected':field.value === option.name}"
						>
							<v-card-text
									class="text-center text-uppercase font-weight-bold"
							>
								<v-img
										:src="'/images/redemption/'+option.icon"
										class="mb-2"
								/>
								{{ option.name }}
							</v-card-text>
						</v-card>
					</label>
				</v-col>
			</v-row>
		</div>
		<div v-else-if="field.type == 'TemplateSelection'">
				<select
						:name="'field-'+field.id"
						class="form-control data-hj-allow"
						:class="fieldAlt ? 'form-control-alt '+classes : classes"
						v-model="field.value"
						@change="changed"
						:disabled="field.type_attributes.indexOf('Disabled') > -1"
				>
					<option :value="null">- Select One -</option>
					<option v-for="option in templates" :value="option.id">{{ option.name }}</option>
				</select>
		</div>
		<div v-else-if="field.type == 'IronCladContract'">
			<div
					:class="[
                    'checkbox-new',
                    'ic-root',
                    !!field.value ? 'selected' : null
                ]"
			>
				<div class="ic-bg v-input__slot"></div>
				<div id="IronClad" ref="IronClad"></div>
				<i
						aria-hidden="true"
						:class="[
						'hidden',
                        'ic-check v-icon notranslate mdi',
                        field.value
                            ? 'mdi-checkbox-marked primary--text'
                            : 'mdi-checkbox-blank-outline'
                    ]"
				></i>
				<v-text-field
						:name="'field-'+field.id"
						class="hidden"
						v-model="field.value"
				></v-text-field>
			</div>
		</div>
		<div v-else-if="field.type == 'Menu'">
			<div v-show="menuItems && menuItems.length">
				<div v-for="item in menuItems">
					<div class="form-group">
						<label>Title</label>
						<input
							type="text"
							v-model="item.title"
							class="form-control"
							:class="fieldAlt ? 'form-control-alt '+classes : classes"
							:disabled="field.type_attributes.indexOf('Disabled') > -1"
							@blur="formatMenuText()"
						/>
					</div>
					<div class="form-group">
						<label>Description</label>
						<input
							type="text"
							v-model="item.description"
							class="form-control"
							:class="fieldAlt ? 'form-control-alt '+classes : classes"
							:disabled="field.type_attributes.indexOf('Disabled') > -1"
							@blur="formatMenuText()"
						/>
					</div>
					<hr />
				</div>
			</div>
			<button
				class="btn btn-info"
				@click.prevent="addMenuItem()"
				:disabled="field.type_attributes.indexOf('Disabled') > -1"
			>
				<i class="fa fa-plus mr-1"></i> Add Menu Item
			</button>
			<div v-show="menuItems && menuItems.length">
				<div>
					<h5>Preview</h5>
					<span v-html="field.value"></span>
				</div>
			</div>
			<input
					type="text"
					v-model="menuValue"
					class="form-control required-hide"
					:data-required="field.required || (field.validation_settings && field.validation_settings.required) ? 'true' : 'false'"
					:required="field.required || (field.validation_settings && field.validation_settings.required)"
					autocomplete="off"
			/>
		</div>
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import $api from "@api/api";
import IronClad from '@services/IronClad/api';

export default {
	props: {
		field: {
			type: Object,
			required: true,
		},
		fieldAlt: {
			type: Boolean,
			default: false,
		},
		classes: {
			type: String,
		},
		rows: {
			type: Number | String,
			default: 3,
		},
		media: {
			type: Array,
		},
		parentId: {
			type: Number,
		},
		user: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	components: {
		Multiselect,
	},
	methods: {
		changed(ev) {
			this.$emit("field-changed", {field:this.field, value:this.field.value, refId:this.parentId});
		},
		getMediaStyle(mediaData) {
			return `width:${mediaData.div_width} !important; height:${mediaData.div_height} !important;`;
		},
		chooseImage(image, type = "new") {
			this.$emit("choose-image", image, type);
		},
		removeImage(image) {
			this.$emit("remove-image", image);
		},
		imageRemoved(newImage) {
			if( this.image && newImage && this.image.assignment == newImage.assignment && this.image.location == newImage.location )
				this.image = newImage;
		},
		saveDate(date, format) {
			this.field.value = Bandwango.dateToUtc(date, format, format);
			this.changed(false);
		},
		toggleCheckbox(value, option) {
			if( !value ) value = [];
			let i = value.indexOf(option);
			if( i > -1 )
				value.splice(i, 1);
			else
				value.push(option);

			this.field.value = value;
			this.changed(false);
			return value;
		},
		toggleRadio(value, isDisabled=false) {
			if( isDisabled ) return;

			this.field.value = value;
			this.changed(false);
		},
		toggleCategory(value, parent=false) {
			if( parent ) {
				this.parentCategory = value;
				this.$set(this.field, 'value', [this.parentCategory]);
				this.changed(false);
			} else {
				if( !this.field.value ){
					this.$set(this.field, 'value', []);
				}
				const temp = [...this.field.value];
				temp.push(value);
				setTimeout(() => {
					this.$set(this.field, 'value', temp);
					this.changed(false);
				}, 50);
			}
		},
		changeToggle() {
			this.field.value = this.field.value ? 0 : 1;
			this.changed(false);
			this.$forceUpdate();
		},
		daySelected(day) {
			day.selected = !day.selected;
			this.formatDayText();
		},
		formatDayText() {
			this.field.value = { periods: [], weekday_text: [] };
			this.days.forEach((day) => {
				if (day.selected) {
					this.field.value.periods.push({
						open: {
							day: day.day,
							time: moment("01/01/2020 " + day.open).format("HHmm"),
						},
						close: {
							day: day.day,
							time: moment("01/01/2020 " + day.close).format("HHmm"),
						},
					});

					this.field.value.weekday_text.push(
						day.label + ": " + day.open + " - " + day.close
					);
				} else {
					this.field.value.weekday_text.push(day.label + ": Closed");
				}
			});
			this.changed(false);
		},
		updateBusinessHours() {
			if (
				this.field.value &&
				this.field.value.periods &&
				this.field.value.periods.length
			) {
				this.field.value.periods.forEach((p) => {
					if (p.open) {
						let day = this.days.find((x) => x.day == p.open.day);
						if (day) {
							day.open = moment(
								"01/01/2020 " + p.open.time,
								"MM/DD/YYYY HHmm"
							).format("h:mm A");
							day.selected = 1;
						}
					}
					if (p.close) {
						let day = this.days.find((x) => x.day == p.close.day);
						if (day) {
							day.close = moment(
								"01/01/2020 " + p.close.time,
								"MM/DD/YYYY HHmm"
							).format("h:mm A");
							day.selected = 1;
						}
					}
				});
			}
		},
		addMenuItem() {
			this.menuItems.push({ title: "", description: "" });
		},
		formatMenuText() {
			this.field.value = "";
			this.menuItems.forEach((item) => {
				this.field.value += "<b>" + item.title + "</b>";
				this.field.value += "<p>" + item.description + "</p>";
				this.field.value += "<br>";
			});
			this.changed(false);
			this.$forceUpdate();
		},
		updateMenu() {
			this.menuItems = [];
			if (this.field.value) {
				const items = this.field.value.split("<br>");
				items.forEach((item) => {
					if (item) {
						const mItem = { title: "", description: "" };
						let result = item.match(/<b>(.*?)<\/b>/g).map(function (val) {
							return val.replace(/<\/?b>/g, "");
						});
						if (result && result.length) mItem.title = result[0];

						result = item.match(/<p>(.*?)<\/p>/g).map(function (val) {
							return val.replace(/<\/?p>/g, "");
						});
						if (result && result.length) mItem.description = result[0];

						this.menuItems.push(mItem);
					}
				});
			}
		},
		valueChanged() {
			// from parent
			if (this.field.type == "Business Hours") {
				this.updateBusinessHours();
			}
		},
		shouldShow() {
			return !this.field.validation_settings || !this.field.validation_settings.originallyHidden || !!this.field.shouldShow;
		},
		async getCategories() {
			this.categories = (await $api.categories.getCategories({type:this.field.settings.category_type})).data;
		},
		getBoundsForAutocomplete(fieldRef) {
			if( this.partner && this.partner.address ) {
				const self = this;
				let g = new google.maps.Geocoder();
				g.geocode({address:`${this.partner.address}`}, (results, status) => {
					if( status == "OK" && results.length ) {
						let bounds = results[0].geometry.bounds;
						if( !bounds )
							bounds = new google.maps.LatLngBounds(results[0].geometry.location);

						self.setUpAutoComplete(fieldRef, bounds);
					} else {
						self.setUpAutoComplete(fieldRef);
					}
				});
			} else {
				this.setUpAutoComplete(fieldRef);
			}
		},
		async getTemplates() {
			const params = {
				parentId: this.field.settings && this.field.settings.template_parent_id || 0
			};
			const {data} = await $api.templates.getTemplates(params);
			this.templates = data;
		},
		setUpAutoComplete(fieldRef, bounds=false)
		{
			const options = {
				fields: [
					"name",
					"geometry.location",
					"place_id",
					"formatted_address",
					"formatted_phone_number",
					"website",
					"opening_hours"
				],
				types: [("address", "establishment")]
			};

			if( bounds ) {
				options.bounds = bounds;
				options.rankBy = google.maps.places.RankBy.DISTANCE;
			}

			this.autocomplete = new google.maps.places.Autocomplete(fieldRef, options);
			this.autocomplete.addListener("place_changed", () => {
				const place = this.autocomplete.getPlace();

				// update venue structure
				this.field.value = place.name;
				this.changed(false);
				this.$emit("field-changed", {field:{field_path:'venue.latitude'}, value:place.geometry.location.lat(), refId:this.parentId});
				this.$emit("field-changed", {field:{field_path:'venue.longitude'}, value:place.geometry.location.lng(), refId:this.parentId});
				this.$emit("field-changed", {field:{field_path:'venue.google_place_id'}, value:place.place_id, refId:this.parentId});
				this.$emit("field-changed", {field:{field_path:'venue.phone'}, value:place.formatted_phone_number, refId:this.parentId});
				this.$emit("field-changed", {field:{field_path:'venue.address'}, value:place.formatted_address, refId:this.parentId});
				this.$emit("field-changed", {field:{field_path:'venue.website'}, value:place.website, refId:this.parentId});
				this.$emit("field-changed", {field:{field_path:'venue.hours'}, value:place.opening_hours, refId:this.parentId});
				this.$emit("field-changed", {field:{field_path:'venue.hours_auto_update'}, value:1, refId:this.parentId});
				this.$forceUpdate();
			});

		},
		async setUpIronClad() {
			const self = this;
			const userEmail = this.user.email;
			const agreement = (await $api.agreements.getAgreement(this.field.settings.agreement_id)).data;
			if( agreement ) {
				const group = await IronClad.groups.getGroup(
					agreement.external_id,
					userEmail,
					{container_selector: 'IronClad'}
				);
				if (group) {
					group.render();

					// TODO:: move this logic to the IronClad api. Kind of hacky
					// _ps is a global js object
					_ps.on('valid', function (params, context) {
						if (params.group === group.parameters?.data?.values[':group'])
							self.field.value = 'agreed';
					});
					_ps(agreement.external_id + ":retrieveHTML", {fullName: this.user.name, userId:this.user.id, agreementId:agreement.id, agreementAssignmentId:this.user.id});
				}
			}
		},
		getReqUserData() {
			if( this.user && this.user.id ) {
				if( this.field.type == "Display Image" || this.field.type == "Image" ) {
					if (this.media && this.media.length)
						this.image = this.media.find(
							(x) => x.location == this.field.type_attributes
						);
				}

				if( this.field.type == "Categories" ) {
					this.getCategories();
				}
			}
		}
	},
	data() {
		return {
			image: null,
			days: [
				{ label: "Sunday", selected: 0, open: "", close: "", day: 0 },
				{ label: "Monday", selected: 0, open: "", close: "", day: 1 },
				{ label: "Tuesday", selected: 0, open: "", close: "", day: 2 },
				{ label: "Wednesday", selected: 0, open: "", close: "", day: 3 },
				{ label: "Thursday", selected: 0, open: "", close: "", day: 4 },
				{ label: "Friday", selected: 0, open: "", close: "", day: 5 },
				{ label: "Saturday", selected: 0, open: "", close: "", day: 6 },
			],
			menuItems: [],
			categories: [],
			parentCategory: null,
			partner:null,
			templates:[],
			userChangeTimeout:null,
		};
	},
	computed: {
		multiselectValue: {
			get() {
				if( !this.field.value_options ) return [];

				return this.field.value_options.filter((opt) => {
					return this.field.value && this.field.value.map(Number).indexOf(opt.id) > -1;
				});
			},
			set(newVal) {
				this.field.value = newVal.map((v) => v.id);
				this.changed();
			}
		},
		parentCategories() {
			return this.categories.filter(x => !x.parent_id);
		},
		childCategories() {
			return this.categories.filter(x => x.parent_id === this.parentCategory);
		},
		menuValue() {
			return this.menuItems?.length && 'value' || null;
		},
	},
	beforeMount() {
		if (!this.field.value) {
			if (this.field.type == "Select" || this.field.type == "Drop Down" || this.field.type == "Check Box") {
				if ( this.field.type_attributes.indexOf("Single Select") > -1 && this.field.type_attributes.indexOf("Single Line") > -1) {
					this.$set(this.field, 'value', []);
				} else {
					this.$set(this.field, 'value', null) // set for Default options, like - Select One -
				}
			} else {
				this.$set(this.field, 'value', null) // set for Default options, like - Select One -
			}
		}
		if (this.field.value_options == null) this.field.value_options = []; // initialize properly when no data
	},
	async mounted() {
		const self = this;

		if( this.partnerId )
			this.partner = (await $api.partners.getCurrentPartner(this.partnerId)).data;

		if (this.field.type_attributes.indexOf("Readonly") > -1)
			this.fieldAlt = false;

		if (this.field.type == "Business Hours") {
			this.updateBusinessHours();
		}

        if (this.field.type == "Menu") {
            this.updateMenu();
        }

        if (this.field.type == "GooglePlace") {
				const ref = this.$refs.autocomplete;
				if (ref) {
					this.getBoundsForAutocomplete(ref);
				}
        }

        if (this.field.type == "TemplateSelection") {
            this.getTemplates();
        }

        if( this.field.type == "IronCladContract" ) {
        	this.setUpIronClad();
		}

        if( !this.field.value ) {
			// if there is a default value and no value then set it. Trigger a change
			if( this.field.default_value ) {
				this.$set(this.field, 'value', this.field.default_value);
				this.changed(false);
			}
		}

        this.getReqUserData();

        // if (this.field.type == "Select" || this.field.type == "Drop Down") {
		// 	setTimeout(() => {
		// 		// mounted triggers 1 tick too early for this kind of stuff.
		// 		$(".chosen-select").select2({width: "100%"});
		// 		// jquery chosen select not playing nicely with vue
		// 		$(".chosen-select").on("change", (ev) => {
		// 			self.field.value = ev.target.value;
		// 			if (ev.target.selectedOptions && ev.target.selectedOptions.length)
		// 				self.field.value = Array.from(ev.target.selectedOptions).map((x) => x.value);
		//
		// 			self.changed(false);
		// 		});
		// 	}, 300);
		// }
  	},
	watch: {
		user: {
			deep: true,
			immediate: true,
			handler() {
				clearTimeout(this.userChangeTimeout);
				this.userChangeTimeout = setTimeout(() =>{
					this.getReqUserData();
				}, 500);
			}
		}
	}
};
</script>

<style lang="scss">
	.required-hide {
		height: 0px !important;
		padding: 0px !important;
		border: transparent !important;
	}
	.redemption-selection {
		&__radio {
			 position: absolute;
			 opacity: 0;
		 }

		& .selected {
			border: 1px solid blue;
		}
	}
	.hidden {
		height: 0px;
		display: none;
		visibility: hidden;
	}
</style>